module.exports = __webpack_public_path__ + "img/codeforcesp.8973d6dd.png";